export type ToastKind = 'error' | 'warning' | 'success';

/** A button on the toast, e.g. "Fortryd"; running it closes the toast. */
export type ToastAction = { label: string; run: () => void | Promise<unknown> };

export type Toast = { id: number; kind: ToastKind; text: string; action?: ToastAction };

/** Successes and warnings hide by themselves; errors stay until they are closed. */
export const TOAST_HIDE_MS = 5000;
const MAX_TOASTS = 3;

/** Short messages stacked above the bottom menu. */
class ToastState {
	items = $state<Toast[]>([]);
	private nextId = 1;

	/** Returns the toast's id. */
	show(text: string, kind: ToastKind = 'error', action?: ToastAction): number {
		const id = this.nextId++;
		const others = this.items.filter((item) => item.text !== text);
		this.items = [...others, { id, kind, text, action }].slice(-MAX_TOASTS);
		if (kind !== 'error') setTimeout(() => this.dismiss(id), TOAST_HIDE_MS);
		return id;
	}

	dismiss(id: number) {
		this.items = this.items.filter((item) => item.id !== id);
	}

	/** Runs the toast's action once and closes it. */
	async act(id: number) {
		const item = this.items.find((toast) => toast.id === id);
		if (!item?.action) return;
		this.dismiss(id);
		await item.action.run();
	}
}

export const toast = new ToastState();
